<template>
  <div>
    <div
      class="suit-test-title"
      data-test="summary-of-suit-test--title"
    >
      {{ $t('summary_of_suit_test.title') }}
    </div>
    <div class="section-white">
      <div class="meter">
        <img :src="`/static/img/suit-test-${riskLevel}-risk.png`">
      </div>
      <p
        class="risk-point"
        v-html="$t('summary_of_suit_test.user_risk_point', { suitabilityTestPoint })"
      />
      <p v-html="$t(`summary_of_suit_test.user_risk_level.${riskLevel}`)"/>
      <article style="padding-top: 25px;">
        {{ $t('summary_of_suit_test.rules_detail') }}
      </article>
      <div
        class="backward-btn"
        @click="$router.push({ name: 'Exchange' })"
      >
        {{ $t('summary_of_suit_test.backward_btn') }}
      </div>
    </div>
    <div
      v-if="!isSubmitKnowledgeTest"
      class="section-white"
    >
      <div class="invite-knowledge-test--container">
        <div class="invite-knowledge-test--text">
          <p class="invite-knowledge-test--title">{{ $t('summary_of_suit_test.invite_knowledge_test.title') }}</p>
          <p class="invite-knowledge-test--describe">{{ $t('summary_of_suit_test.invite_knowledge_test.describe') }}</p>
          <div
            class="knowledge-test-btn"
            @click="$router.push({ name: 'KnowledgeTest' })"
          >
            {{ $t('summary_of_suit_test.invite_knowledge_test.text_btn') }}
          </div>
        </div>
        <div class="invite-knowledge-test--image">
          <img src="/static/img/knowledge-invite.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SummaryOfSuitTest',
  props: {
    suitabilityTestPoint: {
      type: Number,
      default: 0
    },
    isSubmitKnowledgeTest: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      riskLevel: ''
    }
  },
  created () {
    this.calUserRisk()
  },
  methods: {
    calUserRisk () {
      if (this.suitabilityTestPoint <= 10) this.riskLevel = 'low'
      else if (this.suitabilityTestPoint <= 15) this.riskLevel = 'medium'
      else if (this.suitabilityTestPoint <= 25) this.riskLevel = 'hight'
      else this.riskLevel = 'very_hight'
    }
  }
}
</script>

<style lang="scss" scoped>
.suit-test-title {
  margin: 35px 0;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  color: #000000;
}
.section-white {
  display: block;
  margin: 0 auto;
  padding: 50px;
  max-width: 1024px;
  width: calc(100% - 20px);
  border-radius: 3px;
  box-shadow: 0 0 6px -2px rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
  font-size: 18px;
  line-height: 1.44;
  &:last-child {
    margin-top: 48px;
  }
}
.risk-point {
  text-align: center;
  margin: 40px 0 36px 0;
}
.meter {
  display: block;
  text-align: center;
  img {
    width: 400px;
  }
}
.backward-btn {
  width: 165px;
  height: 45px;
  border-radius: 3px;
  box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.5);
  background-color: #2193ff;
  margin: 70px auto 0;
  font-family: Roboto;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.37px;
  text-align: center;
  color: #ffffff;
  padding: 13px 0px;
  cursor: pointer;
}
.invite-knowledge-test {
  &--container {
    display: inline-block;
    position: relative;
    width: 100%;
  }
  &--title {
    font-size: 20px;
    font-weight: bold;
  }
  &--describe {
    font-size: 15px;
    margin: 30px 0;
  }
  &--text {
    float: left;
    width: 60%
  }
  &--image {
    position: absolute;
    right: -35px;
    width: 260px;
    bottom: -44px;
  }
}
.knowledge-test-btn {
  width: 323px;
  height: 45px;
  border-radius: 3px;
  box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.5);
  background-color: #2193ff;
  font-family: Roboto;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.37px;
  text-align: center;
  color: #ffffff;
  padding: 13px 0px;
  cursor: pointer;
}

/* Mobile */
@media only screen and (max-width: 768px) {
  .section-white {
    width: calc(100% - 20px);
    padding: 30px 15px;
    &:last-child {
      margin-top: 20px;
    }
  }
  .invite-knowledge-test {
    &--text {
      width: 100%
    }
    &--image {
      display: none;
    }
  }
  .knowledge-test-btn {
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SummaryOfSuitTest.vue